// 富文本展开/收起、FAQ 循环滚动（供无水合内联调用 / 客户端自动初始化）
export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return

  if (!(window as any).__toggleRichText) {
    ;(window as any).__toggleRichText = (id: string) => {
      try {
        const content = document.getElementById(`rich-text-${id}`)
        if (!content) return

        const btn = document.querySelector(
          `.content-more[data-component-id="${id}"]`
        ) as HTMLElement | null

        const collapsedHeight = (content as HTMLElement).dataset?.collapsedHeight || '795'
        const expanded = btn?.getAttribute('data-expanded') === '1'

        if (!expanded) {
          content.style.height = 'auto'
          content.style.maxHeight = '100%'
          content.style.overflow = 'visible'
          if (btn) {
            btn.setAttribute('data-expanded', '1')
            btn.textContent = '收起'
          }
        } else {
          content.style.maxHeight = `${collapsedHeight}px`
          content.style.overflow = 'hidden'
          if (btn) {
            btn.setAttribute('data-expanded', '0')
            btn.textContent = '查看更多'
            content.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        }
      } catch (err) {
        console.error('toggleRichText error', id, err)
      }
    }
  }

  if ((window as any).__faqScrollSetup) return
  ;(window as any).__faqScrollSetup = true

  const FAQ_SCROLL_INTERVAL = 5000
  const FAQ_VISIBLE_COUNT = 2

  const getItemHeight = (item: HTMLElement) => {
    const style = window.getComputedStyle(item)
    const marginBottom = parseFloat(style.marginBottom) || 0
    return item.offsetHeight + marginBottom
  }

  const initFAQScrollForViewport = (viewport: HTMLElement) => {
    if (viewport.getAttribute('data-faq-inited') === '1') return

    const totalCount = parseInt(viewport.getAttribute('data-faq-count') || '0', 10)
    if (totalCount <= FAQ_VISIBLE_COUNT) return

    const container = viewport.querySelector('#faq-list-container') as HTMLElement | null
    if (!container) return

    const items = container.querySelectorAll<HTMLElement>('.faq-item')
    if (items.length < totalCount * 2) return

    viewport.setAttribute('data-faq-inited', '1')

    let currentIndex = 0

    const setViewportHeight = () => {
      let height = 0
      for (let i = 0; i < FAQ_VISIBLE_COUNT; i++) {
        height += getItemHeight(items[i]!)
      }
      viewport.style.height = `${height}px`
    }

    const getOffsetForIndex = (index: number) => {
      let offset = 0
      for (let i = 0; i < index; i++) {
        offset += getItemHeight(items[i]!)
      }
      return offset
    }

    setViewportHeight()

    const scrollNext = () => {
      currentIndex++
      container.style.transform = `translateY(-${getOffsetForIndex(currentIndex)}px)`

      if (currentIndex >= totalCount) {
        const onTransitionEnd = (e: TransitionEvent) => {
          if (e.target !== container || e.propertyName !== 'transform') return
          container.removeEventListener('transitionend', onTransitionEnd)
          container.classList.add('faq-no-transition')
          currentIndex = 0
          container.style.transform = 'translateY(0)'
          void container.offsetHeight
          container.classList.remove('faq-no-transition')
        }
        container.addEventListener('transitionend', onTransitionEnd)
      }
    }

    let timer: ReturnType<typeof setInterval> | null = null

    const startScroll = () => {
      if (timer) return
      timer = setInterval(scrollNext, FAQ_SCROLL_INTERVAL)
    }

    const stopScroll = () => {
      if (!timer) return
      clearInterval(timer)
      timer = null
    }

    startScroll()

    const faqBox = viewport.closest('.FAQBox') || viewport
    faqBox.addEventListener('mouseenter', stopScroll)
    faqBox.addEventListener('mouseleave', startScroll)
    faqBox.addEventListener('touchstart', stopScroll, { passive: true })
    faqBox.addEventListener('touchend', startScroll)
    faqBox.addEventListener('touchcancel', startScroll)

    window.addEventListener('resize', setViewportHeight)
  }

  const tryInitFAQScroll = () => {
    const viewport = document.getElementById('faq-viewport')
    if (viewport) initFAQScrollForViewport(viewport)
  }

  tryInitFAQScroll()
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInitFAQScroll)
  }

  const observer = new MutationObserver(() => {
    tryInitFAQScroll()
  })
  observer.observe(document.body, { childList: true, subtree: true })
})
